import {
    GuardianClient
} from '../clients/GuardianClient'
import Router from '@/router/index'

export const GuardianModule = {
    namespaced: true,
    state: {
        isLearner: false,
        isGuardian: false,
        learners: [],
        selectedLearner: null
    },


    mutations: {
        //synchronous
        SET_IS_GUARDIAN(state) {
            state.isGuardian = true
        },
        SET_IS_LEARNER(state) {
            state.isLearner = true
        },
        SET_LEARNERS(state, payload) {
            state.learners = payload
        }

    },

    actions: {
        //asynchronous
        setLearner({
                       commit
                   }) {
            commit('SET_IS_LEARNER')
        },
        setGuardian({
                        commit
                    }) {
            commit('SET_IS_GUARDIAN')
        },
        getLearners({
                        rootState,
                        commit
                    }) {
            GuardianClient.getLearners(rootState.auth.user.id).then(({
                                                                         data
                                                                     }) => {

                data.data.forEach((element, index) => {
                    element.color = rootState.calendar.colors[index]
                });
                
                commit('SET_LEARNERS', data.data)
            })
        },

    },
};